import { createContext, useContext } from 'react';

export interface ExistingDocumentRef {
  uri?: string;
  name?: string;
}

export interface ExistingDocumentsValue {
  /** Field path (e.g. "coordinators.0.idCardPhotocopy") -> previously uploaded document. */
  single: Record<string, ExistingDocumentRef>;
  /** Person prefix (e.g. "coordinators.0" / "supporteds.0") -> previously uploaded extra documents. */
  additional: Record<string, ExistingDocumentRef[]>;
}

/**
 * In completion (edit) mode, exposes previously-uploaded documents so the form can show the existing
 * file with a link and let the applicant optionally replace it. Empty in create mode.
 */
export const ExistingDocumentsContext = createContext<ExistingDocumentsValue>({
  single: {},
  additional: {},
});

export const useExistingDocument = (fieldName: string): ExistingDocumentRef | undefined =>
  useContext(ExistingDocumentsContext).single[fieldName];

export const useExistingAdditionalDocuments = (personPrefix: string): ExistingDocumentRef[] =>
  useContext(ExistingDocumentsContext).additional[personPrefix] ?? [];
